import React, { Fragment, useRef } from 'react';
import styles from 'styles/image_picker.module.scss';
import { DragAndDrop, Icon } from 'components';
import {
	faUpload,
} from '@fortawesome/fontawesome-pro-solid';
import classNames from 'lib/classNames';

const ImagePicker = ({ onChange, value , simplified = false}) => {
	const input = useRef(null);
	const readImage = ({ target }) => {
		if (target.files && target.files[0]) {
			const reader = new FileReader();
			reader.onload = function(event) {
				onChange(event.target.result);
			};
			reader.readAsDataURL(target.files[0]);
		}
	};
	const handleDrop = files => {
		input.current.files = files;
		readImage({ target: input.current });
	};
	const id = `fp-${new Date().getTime()}`;
	return (
		<div className={styles.ImagePicker}>
			<input type="file" id={id} onChange={e => readImage(e)} ref={input} />
			<label htmlFor={id}>
				{
					simplified ? 
						<span className={classNames('flex-1 flex items-center justify-center flex-grow ml-2 text-gray-500 text-sm font-bold  cursor-pointer')}>Add icon <Icon icon={faUpload} color="" /></span>
					:
					<DragAndDrop handleDrop={f => handleDrop(f)}>
						{value && (
							<Fragment>
								<div className={styles.image} style={{ backgroundImage: `url(${value})` }} />
								<small>Change</small>
							</Fragment>
						)}
						{!value && (
							<p>
								<b>Choose an image </b> or drag it here.
							</p>
						)}
					</DragAndDrop>
				}
				
			</label>
		</div>
	);
};

export default ImagePicker;
